import { createContext } from "react";
import type { Manifest } from "../film/manifest";

export const CastFilmContext = createContext<Manifest | null>(null);

/** Cast ids are direct; scene-owned ids use `<scene>.<object>`. */
export const objectOf = (key: string): string => {
  const dot = key.indexOf(".");
  return dot >= 0 ? key.slice(dot + 1) : key;
};
